import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../api/api';
import httpClient from '../../client/httpClient';

export const categoryAdd = createAsyncThunk(
    'category/categoryAdd',
    async ({ name, image }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('image', image);
            const { data } = await httpClient.post('v1/api/category/save', formData);
            // console.log(data)
            return fulfillWithValue(data);
        } catch (error) {
            // console.log(error.response.data)
            return rejectWithValue(error.response.data);
        }
    }
);

// End Method

export const get_category = createAsyncThunk(
    'category/get_category',
    async (formData, { rejectWithValue, fulfillWithValue }) => {
        try {
            const pagination = {
                paginationRequestDTO: {
                    pageNo: formData?.page || 1,
                    pageSize: formData?.parPage || 5,
                    sortBy: 'id',
                    sortDir: 'desc'
                }
            };
            let payload = pagination;
            if (formData?.searchValue !== '') {
                payload = { name: formData?.searchValue, ...pagination };
            }
            const { data } = await httpClient.post(
                'v1/api/category/get-by-page',
                payload
            );
            // console.log(data)
            return fulfillWithValue(data);
        } catch (error) {
            // console.log(error.response.data)
            return rejectWithValue(error.response.data);
        }
    }
);

// End Method

export const updateSubSubCategory = createAsyncThunk(
    'category/updateSubSubCategory',
    async ({ id, name, image }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('name', name);
            if (image) {
                formData.append('image', image);
            }
            const { data } = await api.put(`/category-update/${id}`, formData, {
                withCredentials: true
            });
            // console.log(data)
            return fulfillWithValue(data);
        } catch (error) {
            // console.log(error.response.data)
            return rejectWithValue(error.response.data);
        }
    }
);

// End Method

export const deleteCategory = createAsyncThunk(
    'category/deleteCategory',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(`/category/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data.message);
        }
    }
);

// End Method

export const categoryReducer = createSlice({
    name: 'category',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        categories: [],
        totalCategory: 0
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(categoryAdd.pending, (state) => {
                state.loader = true;
            })
            .addCase(categoryAdd.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload.error;
            })
            .addCase(categoryAdd.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
                state.categories = [...state.categories, payload.category];
            })

            .addCase(get_category.fulfilled, (state, { payload }) => {
                state.totalCategory = payload.totalElements;
                state.categories = payload.content;
            })

            .addCase(updateSubSubCategory.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
                const index = state.categories.findIndex(
                    (cat) => cat._id === payload.category._id
                );
                if (index !== -1) {
                    state.categories[index] = payload.category;
                }
            })

            .addCase(updateSubSubCategory.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload.error;
            })

            .addCase(deleteCategory.fulfilled, (state, action) => {
                state.categories = state.categories.filter(
                    (cat) => cat._id !== action.meta.arg
                );
                state.successMessage = action.payload.message;
            })
            .addCase(deleteCategory.rejected, (state, action) => {
                state.errorMessage = action.payload;
            });
    }
});
export const { messageClear } = categoryReducer.actions;
export default categoryReducer.reducer;
